import { render, staticRenderFns } from "./PsiDetailBankInfo.vue?vue&type=template&id=9f25ca20&scoped=true"
import script from "./PsiDetailBankInfo.vue?vue&type=script&lang=js"
export * from "./PsiDetailBankInfo.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailBankInfo.vue?vue&type=style&index=0&id=9f25ca20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f25ca20",
  null
  
)

export default component.exports